$(() => {
  let currentTab;

  const modal = $('#reportMultipleSongs');

  const btnSkuConfirm = modal.find('#btnSkuConfirm');
  const btnSkuCheck = modal.find('#btnSkuCheck');
  const btnSkuBack = modal.find('.btnSkuBack');
  const btnSkuSubmit = modal.find('#btnSkuSubmit');

  const weekSelect = modal.find('.select-reportForWeek');
  const licenseSelect = modal.find('.select-licenseType');

  const currentWeek = $('#reportform select[name=reportweeks]').val();

  let titles = [];

  function submitSkuReport() {
    const form = modal.find('#skuListForm');
    const dataArr = form.serializeArray();
    const btn = $(this);

    btn.button('loading');
    $.post(urlCheckSku, dataArr, (res) => {
      if (!res.isError) {
        if (res.count === 0) {
          btnSkuConfirm.attr('disabled', true);
        } else {
          btnSkuConfirm.attr('disabled', false);
        }

        titles = res.titles;
        modal.find('#skuTable').html(res.html);
        showTab('skuConfirm');
      } else {
        toastr.error(res.msgError);
      }
      btn.button('reset');
    });
  }

  function confirmSkuReport() {
    showTab('skuSubmit');
  }

  function backToForm() {
    if (currentTab === 'skuConfirm') {
      showTab('skuForm');
    } else {
      showTab('skuConfirm');
    }
  }

  function saveReport() {
    const form = modal.find('#reportform');
    let dataArr = form.serializeArray();
    const btn = $(this);
    let selectedWeek = '';

    dataArr = dataArr.map((item) => {
      if (item.name === 'reportweeks') {
        item.name = 'weeks';
        selectedWeek = item.value;
      }

      return item;
    });

    btn.button('loading');
    $.post(urlReportTitles, {
      dataArr,
      titles
    }, (res) => {
      if (!res.isError) {
        if (res.count === 0) {
          btnSkuConfirm.attr('disabled', true);
        } else {
          btnSkuConfirm.attr('disabled', false);
        }

        modal.find('#skuTable').html(res.html);
        modal.modal('hide');

        toastr.success('Songs reported successfuly');

        if (currentWeek === selectedWeek) {
          location.reload();
        }
      } else {
        toastr.error(res.msgError);
      }

      btn.button('reset');
    });
  }

  function licenseTypeSelect() {
    const id = $(this).find('option:selected').val();

    weekSelect.select2({
      disabled: true,
      minimumResultsForSearch: Infinity,
      placeholder: 'loading...'
    });

    $.post(loadWeeksUrl, {
      id
    }, (data) => {
      weekSelect.find('option').remove();

      $.each(data.weeks, (i, item) => {
        weekSelect.append($('<option>', {
          value: i,
          text: item
        }));
      });

      weekSelect.select2({
        disabled: false,
        minimumResultsForSearch: Infinity
      });
    }, 'json');
  }

  function showTab(tab, callback) {
    if (currentTab !== tab) {
      modal.find(`.sku-report-tabs a.hidden[href="#${tab}"]`).tab('show');
      currentTab = tab;
    }
  }

  modal.on('show.bs.modal', (e) => {
    if (licenseSelect.length) {
      weekSelect.html('');
    }

    btnSkuConfirm.removeClass('disabled');
    showTab('skuForm');
  });

  licenseSelect.select2({
    placeholder: 'Select License Type',
    minimumResultsForSearch: Infinity
  });


  if (licenseSelect.length) {
    weekSelect.html('');
    weekSelect.select2({
      placeholder: 'Select Week',
      minimumResultsForSearch: Infinity,
      disabled: true
    });
  } else {
    weekSelect.select2({
      placeholder: 'Select Week',
      minimumResultsForSearch: Infinity

    });
  }

  btnSkuCheck.click(submitSkuReport);
  btnSkuConfirm.click(confirmSkuReport);
  btnSkuBack.click(backToForm);
  btnSkuSubmit.click(saveReport);
  licenseSelect.on('select2:select', licenseTypeSelect);
});
